<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="payroll-adustments-create" color="white"></help-link>
                    <v-btn v-if="hasEditRights" fab dark small color="primary" title="Add Payroll Adjustments" @click="showAdd">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card v-if="!loading" class="elavation-1" style="margin-top:10px;"> 
                <v-toolbar flat height="45px">
                    <v-text-field v-model="search" style="width:15px;margin-bottom:15px;" append-icon="search" label="Search name" single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <span style="margin-left:10px;"><b>{{getCoverageDesc}}</b></span>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="manual_adjustments_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" style="cursor:pointer;" title="Click to view/edit">
                            <td>
                                <v-chip style="margin:-5px 0px 0px -5px;">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>
                                <span v-if="props.item.transType==1">Credit to Payroll</span>
                                <span v-else>Debit to Payroll</span>
                            </td>
                            <td>
                                <span v-if="props.item.transType==1">
                                    <span v-if="props.item.addToTaxableIncome">Included in taxable income</span>
                                    <span v-else>Not included in taxable income</span>
                                </span>
                                <span v-else>
                                    <span v-if="props.item.deductFromTaxableIncome">Deducted from taxable income</span>
                                    <span v-else>Not deducted from taxable income</span>
                                </span>
                            </td>
                            <td>{{numFormat.formatNumber(props.item.amount)}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                            <td>{{props.item.remarks}}</td>
                        </tr>
                    </template>
                </v-data-table> 
             </v-card>
        </v-flex>
        <v-dialog v-model="dialogManualAdjustments" width="550" persistent :fullscreen="isMobile">   
            <adjustments ref="adjustmentsRef" :dialogManualAdjustments.sync="dialogManualAdjustments" @send="createItemHandler"></adjustments>
        </v-dialog>
    </v-layout> 
</template>

<script>

import manualAdjustmentsApi from '@/api/manualadjustments'
import commonfn from '@/common/functions'
import numFormat from '@/common/num_format'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'Adjustments',
    metaInfo: {
        title: 'Adjustments',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Manual Adjustments' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'adjustments': () => import('@/components/Payroll/ManualAdjustments'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            numFormat,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            search: null,
            headers: [
                {text:'Employee', align:'left', value:'lastName', width: '15%', sortable:true},
                {text:'Trans Type', align:'left', value:'transType',  width: '10%', sortable:true},
                {text:'Taxable Income Computation', align:'left', value:'transType',  width: '10%', sortable:true},
                {text:'Amount', align:'left', value:'amount',  width:'5%', sortable:true},
                {text:'Status', align:'left', value:'status',  width:'10%', sortable:true},
                {text:'Remarks', align:'left', value:'',  width:'10%', sortable:false},
            ],
            dialogManualAdjustments: false,
            cutoff_period: null,
            serverDate: null,
            company_details: null,
            manual_adjustments: []
        }
    },
    methods: {
        createItemHandler(data) {
             this.$router.push(`/payroll/adjustments/details/${data}`)
        },
        viewDetails(data) {
            this.$router.push(`/payroll/adjustments/details/${data.manualAdjustmentId}`)
        },
        async showAdd() {
            this.$refs.adjustmentsRef.setAdd(this.selectedCutoffId)
            this.dialogManualAdjustments = true
        },
        async getManualAdjustments(){
            try{
                this.loading = true
                const response = await manualAdjustmentsApi.getByCutoff(this.selectedCutoffId)
                if (response && response.status == 200) {
                    this.manual_adjustments = response.data.items
                    this.cutoff_period = response.data.cutoffItem
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Adjustments'
        })

        this.getManualAdjustments()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        manual_adjustments_filtered() {
            var temp = this.manual_adjustments

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
                             item.lastName.toLowerCase().includes(this.search.toLowerCase())
                            )
                })
            }
            return temp
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        selectedCutoffId() {
            return this.$route.params.cutOffId
        },
        getCoverageDesc() {
            if (this.cutoff_period!=null)
                return this.$moment(this.cutoff_period.cutoffStart).format('MMM DD, YYYY') + ' - ' + this.$moment(this.cutoff_period.cutoffEnd).format('MMM DD, YYYY')
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>